/**
 * Convert an object to URLSearchParams with proper array handling.
 * Arrays are serialized as repeated query parameters (e.g., ?key=val1&key=val2)
 * which is what Django REST Framework expects for array filters.
 */
function toURLSearchParams(params: Record<string, unknown>): URLSearchParams {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    // Skip null/undefined values
    if (value == null) {
      return;
    }

    if (Array.isArray(value)) {
      // For arrays, append each item with the same key
      value.forEach((item) => {
        if (item != null) {
          searchParams.append(key, String(item));
        }
      });
    } else {
      // For non-arrays, append as-is
      searchParams.append(key, String(value));
    }
  });

  return searchParams;
}

export default toURLSearchParams;
